@if (topTemplate(); as topTemplate) {
  <div class="app-table__top">
    <ng-container *ngTemplateOutlet="topTemplate"></ng-container>
  </div>
}

<p-table
  [value]="items()"
  [dataKey]="dataKey()"
  [selection]="canSelected() ? selectedItems() : null"
  [loading]="loading()"
  (selectionChange)="onRowSelect($event)"
>
  <ng-template #header>
    <tr>
      @if (canSelected()) {
        <th>
          <p-tableHeaderCheckbox />
        </th>
      }

      @if (headerTemplate(); as headerTemplate) {
        <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
      }

      @if (withOptions()) {
        <th class="app-table__options-cell"></th>
      }
      @if (additionalButtonName()) {
        <th class="app-table__button-cell"></th>
      }
    </tr>
  </ng-template>

  <ng-template
    #body
    let-rowData
  >
    <tr (click)="onRowClick(rowData)">
      @if (canSelected()) {
        <td>
          <p-tableCheckbox [value]="rowData" />
        </td>
      }

      @if (bodyTemplate(); as bodyTemplate) {
        <ng-container *ngTemplateOutlet="bodyTemplate; context: { $implicit: rowData }"></ng-container>
      }

      @if (withOptions()) {
        <td class="app-table__options-cell">
          @if (canShowOptions()) {
            <div class="app-table__options">
              <button
                appButtonIcon
                [appMenu]="menuItems()"
                [appMenuContext]="rowData"
              >
                <svg icon="dots-horizontal" />
              </button>
            </div>
          }
        </td>
      }

      @if (additionalButtonName()) {
        <td class="app-table__button-cell">
          <button
            appButtonIcon
            class="app-table__button-cell_btn"
            (click)="onButtonClick(rowData); $event.stopPropagation()"
          >
            <svg
              class="app-table__button-cell_svg"
              [icon]="additionalButtonName()"
            />
          </button>
        </td>
      }
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td
        colspan="100"
        class="app-table__empty-message"
      >
        {{ 'shared.ui.table.empty' | translate }}
      </td>
    </tr>
  </ng-template>
</p-table>

@if (footerTemplate(); as footerTemplate) {
  <div class="app-table__footer">
    <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
  </div>
}
